var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-img', _vm._b({
    attrs: {
      "max-width": "unset"
    },
    on: {
      "click": _vm.onClick
    }
  }, 'v-img', {
    src: _vm.src,
    style: _vm.style
  }, false), [_vm._t("default")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }